module.exports = __webpack_public_path__ + "static/media/1.29217150.jpg";